import {defineCustomElement} from 'extensions/ui-utils';
import stylesheet from './x-warranty-lookup.scss?as=stylesheet';
import {html, LitElement} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import 'extensions/ui-components/g-modal';
import 'extensions/ui-components/x-loader';

export class WarrantyLookup extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			loading: {
				type: Boolean
			},
			serial: {
				type: String
			},
			warrantyResponse: {
				type: Object
			}
		};
	}

	constructor () {
		super();
		this.errorMessage = '';
		this.loading = false;
		this.serial = '';
		this.warrantyResponse = {};
	}

	async apiRequest (data) {
		this.loading = true;
		const response = await fetch(window.mivaJS?.API_Url, {
			body: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'POST'
		});

		this.loading = false;
		return response.json();
	}

	async handleLookup () {
		const serialValue = this.shadowRoot.getElementById('serial-input');
		this.serial = serialValue.value;

		const requestBody = {
			function: 'GET_WARRANTY_DATES',
			// eslint-disable-next-line camelcase
			serial_number: this.serial
		};


		this.warrantyResponse = await this.apiRequest(requestBody);

		if (this.warrantyResponse.success === 1) {
			this.errorMessage = '';
			const warrantyElement = this.shadowRoot.getElementById('warranty-modal');
			warrantyElement.open();
		} else {
			this.errorMessage = html`<span class="error-icon" aria-hidden="true"></span> Unable to locate serial number. Please contact General Assist.`;
		}
	}

	formatDate (date) {
		let formattedDate = new Date(date);
		return `${formattedDate.getDate()}-${formattedDate.getMonth() + 1}-${formattedDate.getFullYear()}`;
	}

	renderModalContent () {
		return html`
			<div>
				<span class="serial-title">Serial Number:</span> 
				<span class="serial-number">${ this.serial }</span>
			</div>
			<div class="warranty-data-container">
				<div>
					<p class="warranty-heading">Warranty Period:</p>
					<p class="warranty-data">${ this.warrantyResponse?.data?.period } months</p>
				</div>
				<div>
					<p class="warranty-heading">Date Sold:</p>
					<p class="warranty-data">${ this.formatDate(this.warrantyResponse?.data?.startDate) }</p>
				</div>
				<div>
					<p class="warranty-heading">Expires On:</p>
					<p class="warranty-data">${ this.formatDate(this.warrantyResponse?.data?.expiryDate) }</p>
				</div>
			</div>
		`;
	}

	renderModal () {
		return html`
			<g-modal small="true" align="top" id="warranty-modal">
				<div slot="title" class="warranty-lookup__title">
					Warranty Status
				</div>
				<div slot="content">
					${ this.renderModalContent() }
				</div>
			</g-modal>
		`;
	}

	renderLookupButton () {
		if (this.loading) {
			return html`<div class="loading-graphic-container u-border-none u-text-normal"><x-loader class="loading-graphic"></x-loader></div>`;
		}
		return html`<button class="c-control-group__button lookup__icon u-border-none u-text-normal" @click="${this.handleLookup}"><span class="u-hide-visually">Lookup</span></button>`;
	}

	render () {
		const classes = {
			'error-container': true,
			hidden: this.errorMessage === ''
		};

		return html`
			<div class="warranty-lookup-container">
				<input type="text" name="serialNumber" id="serial-input" value="${this.serial}" class="c-form-input" />
				${ this.renderLookupButton() }
			</div>
			<div class="${classMap(classes)}">${ this.errorMessage }</div>
			${this.renderModal()}
		`;
	}
};

defineCustomElement('x-warranty-lookup', WarrantyLookup);
